import createIcon from '../../createIcon';

/**
 * @component @name AddLink
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCA5LjVIMTZWMTEuNUg4VjkuNVpNMjAuMSAxMC41SDIyQzIyIDcuNzQgMTkuNzYgNS41IDE3IDUuNUgxM1Y3LjRIMTdDMTguNzEgNy40IDIwLjEgOC43OSAyMC4xIDEwLjVaTTMuOSAxMC41QzMuOSA4Ljc5IDUuMjkgNy40IDcgNy40SDExVjUuNUg3QzQuMjQgNS41IDIgNy43NCAyIDEwLjVDMiAxMy4yNiA0LjI0IDE1LjUgNyAxNS41SDExVjEzLjZIN0M1LjI5IDEzLjYgMy45IDEyLjIxIDMuOSAxMC41Wk0xOSAxMC41SDE3VjEzLjVIMTRWMTUuNUgxN1YxOC41SDE5VjE1LjVIMjJWMTMuNUgxOVYxMC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddLink = createIcon('AddLink', [
  [
    'path',
    {
      d: 'M8 9.5H16V11.5H8V9.5ZM20.1 10.5H22C22 7.74 19.76 5.5 17 5.5H13V7.4H17C18.71 7.4 20.1 8.79 20.1 10.5ZM3.9 10.5C3.9 8.79 5.29 7.4 7 7.4H11V5.5H7C4.24 5.5 2 7.74 2 10.5C2 13.26 4.24 15.5 7 15.5H11V13.6H7C5.29 13.6 3.9 12.21 3.9 10.5ZM19 10.5H17V13.5H14V15.5H17V18.5H19V15.5H22V13.5H19V10.5Z',
      key: '14vq4x',
    },
  ],
]);

export default AddLink;
